// Organisation Setup — franchise arrangements beside the Restaurant Groups.
// One flat map per language, identical keys (see parts/README.md).

export const en = {
  'org.nav': 'Organisation',
  'org.title': 'Organisation Setup',
  'org.subtitle': 'Who operates each slice of the company, under what agreement — beside the groups that carve it up.',
  'org.loading': 'Loading…',
  'org.noRestaurant': 'No restaurant selected.',

  'org.groups.title': 'Restaurant groups',
  'org.groups.manage': 'Manage groups',
  'org.groups.hint': 'Brands, regions or chains, each owning some of the branches. Created and mapped on the Restaurant Groups screen — shown here as context.',
  'org.groups.none': 'No groups yet.',
  'org.groups.branches': '{n} branch(es)',
  'org.groups.ungrouped': '{n} branch(es) sit in no group.',

  'org.fr.title': 'Franchise arrangements',
  'org.fr.add': 'Add arrangement',
  'org.fr.hint': 'One row per agreement — covering the whole company, one group, or one branch. These are records, not billing: nothing here changes what a guest pays.',
  'org.fr.none': 'Nothing recorded — every outlet is treated as company-operated until an arrangement says otherwise.',
  'org.fr.covers': 'Covers',
  'org.fr.arrangement': 'Arrangement',
  'org.fr.franchisee': 'Franchisee',
  'org.fr.royalty': 'Royalty',
  'org.fr.marketing': 'Marketing',
  'org.fr.monthlyFee': 'Monthly fee',
  'org.fr.term': 'Term',
  'org.fr.status': 'Status',
  'org.fr.active': 'Active',
  'org.fr.ended': 'Ended',
  'org.fr.open': 'open',
  'org.fr.editTitle': 'Edit arrangement',
  'org.fr.deleteTitle': 'Delete this arrangement?',
  'org.fr.deleteDesc': 'The record of who operates the outlet is removed. Orders and settings are untouched.',

  'org.scope.company': 'Whole company',
  'org.scope.groups': 'Groups',
  'org.scope.branches': 'Branches',
  'org.scope.group': 'Group',
  'org.scope.branch': 'Branch',

  'org.type.COMPANY_OWNED': 'Company owned',
  'org.type.FRANCHISED': 'Franchised',
  'org.type.JOINT_VENTURE': 'Joint venture',
  'org.type.MANAGED': 'Management contract',

  'org.form.active': 'Active',
  'org.form.company': 'Franchisee company',
  'org.form.contact': 'Contact person',
  'org.form.brn': 'BRN',
  'org.form.phone': 'Phone',
  'org.form.email': 'Email',
  'org.form.royaltyPct': 'Royalty %',
  'org.form.marketingPct': 'Marketing %',
  'org.form.from': 'Agreement from',
  'org.form.until': 'Until (empty = open-ended)',
  'org.form.territory': 'Exclusive territory',
  'org.form.notes': 'Notes',

  'org.common.save': 'Save',
  'org.common.cancel': 'Cancel',
  'org.common.delete': 'Delete',
};

export const fr = {
  'org.nav': 'Organisation',
  'org.title': 'Structure de l’organisation',
  'org.subtitle': 'Qui exploite chaque partie de la société, sous quel contrat — à côté des groupes qui la découpent.',
  'org.loading': 'Chargement…',
  'org.noRestaurant': 'Aucun restaurant sélectionné.',

  'org.groups.title': 'Groupes de restaurants',
  'org.groups.manage': 'Gérer les groupes',
  'org.groups.hint': 'Enseignes, régions ou chaînes, chacune détenant une partie des succursales. Créés et affectés sur l’écran Groupes de restaurants — affichés ici pour situer.',
  'org.groups.none': 'Aucun groupe pour le moment.',
  'org.groups.branches': '{n} succursale(s)',
  'org.groups.ungrouped': '{n} succursale(s) sans groupe.',

  'org.fr.title': 'Contrats de franchise',
  'org.fr.add': 'Ajouter un contrat',
  'org.fr.hint': 'Une ligne par contrat — couvrant toute la société, un groupe ou une succursale. Ce sont des fiches, pas de la facturation : rien ici ne change ce que paie le client.',
  'org.fr.none': 'Rien d’enregistré — chaque établissement est exploité en propre tant qu’un contrat ne dit pas le contraire.',
  'org.fr.covers': 'Couvre',
  'org.fr.arrangement': 'Contrat',
  'org.fr.franchisee': 'Franchisé',
  'org.fr.royalty': 'Redevance',
  'org.fr.marketing': 'Marketing',
  'org.fr.monthlyFee': 'Forfait mensuel',
  'org.fr.term': 'Durée',
  'org.fr.status': 'Statut',
  'org.fr.active': 'Actif',
  'org.fr.ended': 'Terminé',
  'org.fr.open': 'en cours',
  'org.fr.editTitle': 'Modifier le contrat',
  'org.fr.deleteTitle': 'Supprimer ce contrat ?',
  'org.fr.deleteDesc': 'La fiche de l’exploitant est retirée. Commandes et réglages ne bougent pas.',

  'org.scope.company': 'Toute la société',
  'org.scope.groups': 'Groupes',
  'org.scope.branches': 'Succursales',
  'org.scope.group': 'Groupe',
  'org.scope.branch': 'Succursale',

  'org.type.COMPANY_OWNED': 'En propre',
  'org.type.FRANCHISED': 'Franchisé',
  'org.type.JOINT_VENTURE': 'Coentreprise',
  'org.type.MANAGED': 'Contrat de gestion',

  'org.form.active': 'Actif',
  'org.form.company': 'Société franchisée',
  'org.form.contact': 'Personne de contact',
  'org.form.brn': 'BRN',
  'org.form.phone': 'Téléphone',
  'org.form.email': 'E-mail',
  'org.form.royaltyPct': 'Redevance %',
  'org.form.marketingPct': 'Marketing %',
  'org.form.from': 'Début du contrat',
  'org.form.until': 'Fin (vide = sans terme)',
  'org.form.territory': 'Territoire exclusif',
  'org.form.notes': 'Notes',

  'org.common.save': 'Enregistrer',
  'org.common.cancel': 'Annuler',
  'org.common.delete': 'Supprimer',
};
